module.exports = __webpack_public_path__ + "img/datawise1.89308fd4.png";